import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en/translation.json'
import fr from './locales/fr/translation.json'
import zh from './locales/zh/translation.json'

export const LANGUAGE_KEY = 'language'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      zh: { translation: zh },
    },
    lng: localStorage.getItem(LANGUAGE_KEY) || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })

document.documentElement.lang = i18n.language

export default i18n
